import React from "react";

function Sofafurniture() {
  return (
    <div>
      <h1>Sofafurniture</h1>
      <p>
        Lorem ipsum dolor, sit amet consectetur adipisicing elit. Repellendus,
        maxime facilis eius minus temporibus aliquid repellat a magni cumque
        eligendi expedita. Id ipsa dolorum laudantium incidunt fugiat eligendi,
        labore a?
      </p>
    </div>
  );
}

export default Sofafurniture;
